'use client'

import { cn } from '@mntn-dev/ui-utilities'

import type { AbstractImage, AbstractImageProps } from '@mntn-dev/ui-utilities'

type InfoModalImageProps = AbstractImageProps &
  Readonly<{
    image: AbstractImage
  }>

export const FullPageModalImage = ({
  className,
  image: Image,
  ...rest
}: InfoModalImageProps) => {
  return <Image className={cn('rounded-sm opacity-90', className)} {...rest} />
}
